export const purple = {
  100: 'var(--bfc-v2-color-purple-100, #f8eefe)',
  200: 'var(--bfc-v2-color-purple-200, #dfd8fd)',
  300: 'var(--bfc-v2-color-purple-300, #b8acf6)',
  400: 'var(--bfc-v2-color-purple-400, #9f8fef)',
  500: 'var(--bfc-v2-color-purple-500, #8f7ee7)',
  600: 'var(--bfc-v2-color-purple-600, #8270db)',
  700: 'var(--bfc-v2-color-purple-700, #6e5dc6)',
  800: 'var(--bfc-v2-color-purple-800, #5e4db2)',
  900: 'var(--bfc-v2-color-purple-900, #352c63)',
  1000: 'var(--bfc-v2-color-purple-1000, #2b273f)',
  DEFAULT: 'var(--bfc-v2-color-purple-700, #6e5dc6)', // 700
};
